module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8.7691ad65.png";